module.exports = __webpack_public_path__ + "static/media/hierarchy.5e685eb9.svg";